module.exports = __webpack_public_path__ + "static/media/Curtain Wall Mullion Tags.b33eb65e.png";